import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Avoid using generic or common path names like `}<inlineCode parentName="p">{`/analytics`}</inlineCode>{`, `}<inlineCode parentName="p">{`/tracking`}</inlineCode>{`, `}<inlineCode parentName="p">{`/ingest`}</inlineCode>{`, or `}<inlineCode parentName="p">{`/posthog`}</inlineCode>{` for your reverse proxy. They will most likely be blocked. Instead, use a non-obvious path name or something random and unique to your application that's unlikely to appear in a filter list.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      